<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    methods: {},
};
</script>
<style>
#app {
    background: #f4f4f4;
}
.pageContent {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    padding: 30px 0;
}
</style>
